import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing
import contractShape1 from '../../assets/images/shapes/contact-three-shape-1.png';
import ContactComponent from '../home-4/ContactComponent';
// import contractShape1 from '../../assets/images/shapes/c';
const services = [
    "Choose an Option",
    "Movable Excavator",
    "Scrap Magnet",
    "Vertical Heavy Duty Scrap Shear",
    "Hydraulic Scrap Baler",
    "Horizotal Automatic Container Shear",
    "Fixed Boom Excavator",
    "Scrap Grabber"

];
const ContactMain = () => {
    const [selectedService, setSelectedService] = useState(services[0]);
    const contactInfo = {
        "Mandi Gobindgarh": [
            { address: "First Floor, Near Bansal Auto, G.T. Road, Sirhind Side, Opp. Chanan Ram Diwan Chand petrol pump, Mandi Gobindgarh, Tehsil Amloh, Distt. Fatehgarh Sahib" },
            // { number: "(208) 555-0112", link: "tel:2085550112" }
        ],
        Panipat: [
            { address: "Near SD Vidya Mandir, T Market Sector 12 Huda, Panipat,pin 132103, Haryana" },
            // { number: "(208) 555-0112", link: "tel:2085550112" }
        ],
        Bahadurgarh: [
            { address: "147 Ground Floor Happy Home, Omex city Bahadurgarh Haryana, 124507" },
            // { number: "(208) 555-0112", link: "tel:2085550112" }
        ],
        Surat: [
            { address: "305 Rajhans Complex, near Nirmal Hospital,Ring Road, Surat 395002" }
            // { number: "(208) 555-0112", link: "tel:2085550112" }
        ]
    };

    return (
        <React.Fragment>
            {/* Google Map Start */}
            <section className="google-map-one">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3421.965313130663!2d75.87659157613814!3d30.94353327541335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a8361224c4b77%3A0x56dd7352f2bbcbac!2sRAMANA%20INTERNATIONAL%20PVT.%20LTD.!5e0!3m2!1sen!2sin!4v1742619130699!5m2!1sen!2sinhttps://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3421.9661733888597!2d75.87716020115647!3d30.943509249922556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a837f71078db3%3A0xb2a5e27c63c44247!2sRamana%20Steels!5e0!3m2!1sen!2sin!4v1742619389528!5m2!1sen!2sin"
                    className="google-map__one"
                    allowFullScreen
                    title="Map showing location of Ramana Machines"
                />

            </section>
            <ContactComponent />
            {/* Google Map End */}

            {/* Contact Page Start */}
            <section className="contact-page">
                <div className="container center-align">



                    {/* <div className="contact-page__inner">
                        <p className="contact-page__sub-title">Contact Us</p>
                        <h3 className="contact-page__title">Get In Touch</h3>
                        <form
                            className="contact-form-validated contact-page__form"
                            action="assets/inc/sendemail.php"
                            method="post"
                            noValidate
                        >
                            <div className="row">
                                <div className="col-xl-6 col-lg-6">
                                    <div className="contact-page__input-box">
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Your Name"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6">
                                    <div className="contact-page__input-box">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Your Email"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6">
                                    <div className="contact-page__input-box">
                                        <input
                                            type="text"
                                            name="phone"
                                            placeholder="Your Number"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6">
                                    <div className="contact-page__input-box">
                                        <div className="select-box">
                                            <select className="selectmenu wide">
                                                <option value="">Choose an Option</option>
                                                <option>Type Of Service 01</option>
                                                <option>Type Of Service 02</option>
                                                <option>Type Of Service 03</option>
                                                <option>Type Of Service 04</option>
                                                <option>Type Of Service 05</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-12">
                                    <div className="contact-page__input-box text-message-box">
                                        <textarea
                                            name="message"
                                            placeholder="Message here.."
                                            defaultValue=""
                                        />
                                    </div>
                                    <div className="contact-page__btn-box">
                                        <button type="submit" className="thm-btn-two contact-page__btn">
                                            Appointment Now
                                            <span className="icon-dubble-arrow-right" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="result" />
                    </div> */}
                </div>
                <div className="container">
                    <div className="contact-page__contact-list">
                        <div className="row">
                            {/* Contact Page Contact List Single Start */}
                            {Object.entries(contactInfo).map(([key, values]) => (
                                <div key={key} className="col-xl-6 col-lg-6">
                                    <div className="contact-page__contact-list-single">
                                        <div className="contact-page__contact-list-icon">
                                            <span className={`icon-${key === 'phone' ? 'call' : key === 'email' ? 'envelope' : 'location'}`} />
                                        </div>
                                        <div className="contact-page__contact-list-content">
                                            <h3>{key.charAt(0).toUpperCase() + key.slice(1)}</h3>
                                            {Array.isArray(values) ? (
                                                values.map((item, index) => (
                                                    <p key={index}>
                                                        <Link to={item.link}>{item.number || item.address}</Link>
                                                    </p>
                                                ))
                                            ) : (
                                                <p>{values}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </section>
            {/* Contact Page End */}
        </React.Fragment>
    );
};

export default ContactMain;
